import React from 'react'
import ImmutablePropTypes from 'react-immutable-proptypes'

class FlywheelCancelled extends React.Component {
	render() {
		const { migrate } = this.props
		return <div className="fw d-flex"> 
			<div className="container"> 
				<div className="jumbotron"> 
					<img className="checkmark-circle" src="/assets/exclamation_circle.svg" alt=""/> 
					<h1 className="fw-600">Migration cancelled</h1> 
					<p> 
						<a href={migrate.get('source_site')} target="_blank" className="font16">{migrate.get('source_site')}</a>
						<img className="arrow-icon" src="/assets/arrow_right.svg" alt=""/> 
						<a href={migrate.get('destination_site')} target="_blank" className="font16">{migrate.get('destination_site')}</a>
					</p> 
				</div> 
				<hr/> 
				<div className="subsection"> 
					<p className="text-center font13">Don&apos;t have the time?&nbsp;
						<a href="https://app.getflywheel.com/migration" target="_blank">Let us migrate your site for free!</a>
					</p>
				</div> 
			</div> 
		</div>
	}
}

FlywheelCancelled.propTypes = {
	migrate: ImmutablePropTypes.map
}

export default FlywheelCancelled
